import React, { useEffect, useState } from "react";
import "./LoanSetup.scss";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import LoanCategories from "./LoanCategories/LoanCategories";
import LoanProducts from "./LoanProducts/LoanProducts";
import LoanTypes from "./LoanTypes/LoanTypes";
import CustomAlert from "../../components/UI/CustomAlert/CustomAlert";
import LoanLangTagsTable from "../../components/LoanLangTagsTable/LoanLangTagsTable";
import LoanLanguages from "./LoanLanguages/LoanLanguages";
import LoanCurrMessages from "./LoanCurrMessages/LoanCurrMessages";
import LoanBankCodes from "./LoanBankCodes/LoanBankCodes";
import SchemeGovernance from "./SchemeGovernance/SchemeGovernance";
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import "../../features/userLoans/styles/LoanAdminTheme.scss";

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            style={{
                backgroundColor: "white",
            }}
            
        >
            {value === index && (
            <Box sx={{ p: 3 }} className="loans-setup-custom-tab-container">
               {children}
            </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
}

const LoanSetup = () => {
    const [value, setValue] = useState(0);
    const [categoryData, setCategoryData] = useState(null);
    const [langIdTableData, setLangIdTableData] = useState(null);
    const [fromTab, setFromTab] = useState(null);
    const [alertOpen, setAlertOpen] = useState(false);
    
    const handleChange = (event, newValue) => {
        setCategoryData(null)
        setValue(newValue);
        setLangIdTableData(null);
    };

    const [alert, setAlert] = useState({
        showAlert: false,
        severity: "",
        header: "",
        message: "",
        onConfirm: null,
        alertType: ''
    });

    useEffect(()=>{
        if(categoryData && categoryData !== null) {
            setValue(2);
        }
    },[categoryData])

    const handleViewCategoryLoanProducts = async(categoryData) => {
        console.log("handleViewCategoryLoanProducts=============",categoryData);
        setCategoryData(categoryData);
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setAlertOpen(false);
    };

    return (
        <Box className="page-container loan-admin-page loan-setup-admin">
            <Box className="loan-admin-header">
                <Box>
                    <Typography className="loan-admin-eyebrow">Lending configuration</Typography>
                    <Typography component="h1" className="loan-admin-title">Loan Setup</Typography>
                    <Typography className="loan-admin-description">Configure loan categories, products, types, languages and servicing messages.</Typography>
                </Box>
            </Box>
            <Box className="batch-tabs loan-admin-panel">
                <Box sx={{ width: "100%" }}>
                    <Box sx={{ borderRadius: "12px", backgroundColor: "#f8f8f8" }}>
                        {/* Styling for the tabs */}
                        <Tabs
                            className="loan-admin-tabs"
                            value={value}
                            onChange={handleChange}
                            variant="scrollable"
                            scrollButtons="auto"
                            allowScrollButtonsMobile
                            TabIndicatorProps={{ style: { display: "none" } }}
                            sx={{
                                "& .MuiTab-root": {
                                textTransform: "capitalize",
                                color: "#BCBCBC",
                                fontFamily: "Inter",
                                fontSize: 15,
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "30px",
                                backgroundColor: "#f8f8f8",
                                width: "178px",
                                "&.Mui-selected": {
                                    backgroundColor: "white",
                                    color: "#5523D2",
                                    borderRadius: "6px 6px 0 0 !important",
                                    textAlign: "center",
                                    fontSize: 15,
                                    fontStyle: "normal",
                                    fontWeight: 600,
                                    lineHeight: "30px",
                                    borderBottom: 0,
                                    borderBottomColor: "#FAC800",
                                    borderBottomWidth: 4,
                                },
                                },
                            }}
                        >
                            <Tab label="Scheme Governance" {...a11yProps(0)} />
                            <Tab label="Loan Categories" {...a11yProps(1)} />
                            <Tab label="Loan Products" {...a11yProps(2)} />
                            <Tab label="Loan Types" {...a11yProps(3)} />
                            <Tab label="Languages" {...a11yProps(4)} />
                            <Tab label="Lang Tags" {...a11yProps(5)} />
                            <Tab label="Currency Message" {...a11yProps(6)} />
                            <Tab label="Bank Codes" {...a11yProps(7)} />
                        </Tabs>
                    </Box>{" "}
                    <CustomTabPanel value={value} index={0} className="">
                        <SchemeGovernance />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1} className="">
                        <LoanCategories setAlert={setAlert} setAlertOpen={setAlertOpen} alert={alert} handleViewCategoryLoanProducts={handleViewCategoryLoanProducts} />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={2} className="">
                        <LoanProducts setAlert={setAlert} setAlertOpen={setAlertOpen} alert={alert} categoryData={categoryData} />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={3} className="">
                        <LoanTypes setAlert={setAlert} setAlertOpen={setAlertOpen} alert={alert} setParentTabValue={setValue} setLangIdTableData={setLangIdTableData} />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={4} className="">
                        <LoanLanguages setAlert={setAlert} setAlertOpen={setAlertOpen} />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={5} className="">
                        <LoanLangTagsTable setAlert={setAlert} setAlertOpen={setAlertOpen} alert={alert} langIdTableData={langIdTableData} fromTab={fromTab} setValue={setValue} />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={6} className="">
                        <LoanCurrMessages setAlert={setAlert} setAlertOpen={setAlertOpen} setValue={setValue} setLangIdTableData={setLangIdTableData} setFromTab={setFromTab} />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={7} className="">
                        <LoanBankCodes setAlert={setAlert} setAlertOpen={setAlertOpen} />
                    </CustomTabPanel>
                </Box>
            </Box>

            {alert.severity !== "success" && 
                <CustomAlert
                    severity={alert.severity}
                    show={alert.showAlert}
                    header={alert.header}
                    message={alert.message}
                    onClick={() => {
                        setAlert({ ...alert, showAlert: false });
                    }}
                    alertType={alert.alertType}
                    confirmButton={alert.onConfirm}
                    autoclose={alert.severity === "error" ? false : true}
                />
            }

            <Box className="snackbar-container">
                {alert.severity == "success" && 
                    <Snackbar 
                    open={alertOpen} 
                    autoHideDuration={4000} 
                    onClose={handleClose} 
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right'
                    }}
                    >
                    <Alert
                        onClose={handleClose}
                        severity="success"
                        variant="filled"
                        sx={{ width: '100%' }}
                        autoHideDuration={null}
                    >
                        {alert.message}
                    </Alert>
                    </Snackbar>
                }
            </Box>
        </Box>
    )
}

export default LoanSetup;
